module.exports = __webpack_public_path__ + "static/logo-light-fca537d8520c2c6da1f02c9a5ad5f288.svg";